import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";
import { LinearEntitiesQuery } from "@reflag/shared/linearConnectionAPI";

export function useLinearTrackingEntitySearch(
  searchTerm?: string,
  params: Omit<LinearEntitiesQuery, "searchTerm"> = { maxResults: 10 },
) {
  const { org } = useEnvironment();

  return useQuery({
    queryKey: integrationQueryKeys.linearTrackingEntities(org.id, searchTerm),
    queryFn: () =>
      api
        .get<"/orgs/:orgId/linear/connection/search-entities">(
          `/orgs/${org.id}/linear/connection/search-entities`,
          {
            params: {
              searchTerm,
              ...params,
            },
          },
        )
        .then((res) => res.data),
    enabled: Boolean(org.integrations.linear),
  });
}
